import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DeleteOutline, EditOutlined, Notes } from '@mui/icons-material';
import { FilterBar, TableData } from '../../../components';
import { confirmAlert, errorAlert } from '../../../helpers/alerts';
import { deleteTaskService, getTasksService } from '../../../services/admin/taskService';
import { removeTask, setCurrentTask, setTasks } from '../../../redux/slices/admin/taskSlice';
import moment from 'moment';
import DialogModal from 'components/modal/DialogModal';
import { validatePermission } from 'helpers/authentication';

const TaskScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { tasks } = useSelector(store => store.task);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState({ open: false, title: '', body: '' });

  const handlerEdit = (data) => {
    dispatch(setCurrentTask(data));
    navigate("../editar");
  };

  const handlerSubmit = (data) => {
    setLoading(true);
    data.page = page;
    data.limit = rowsPerPage;
    getTasksService(data).then((response) => {
      dispatch(setTasks(response))
    }).catch(error => errorAlert(error))
      .finally(() => setLoading(false));
  }

  const handlerDelete = (row) => {
      confirmAlert({
        title: 'Estas seguro que deseas eliminar esta tarea?',
        text: `La tarea '${row.alertEvent?.identification}' será eliminada.`,
        onConfirm: async () => {
          try {
            await deleteTaskService(row.id);
            dispatch(removeTask(row.id));
          } catch (error) {
            errorAlert(error);
          }
        },
      });
    };

  const sortedTasks = [...tasks].sort((a, b) => {
    const order = { "Pendiente": 0, "En proceso": 1, "Finalizada": 2 };
    const stateDiff = (order[a.state] ?? 3) - (order[b.state] ?? 3);
    if (stateDiff !== 0) return stateDiff;
    return new Date(b.createdAt) - new Date(a.createdAt);
  });

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        page={page}
        limit={rowsPerPage}
        showTitle={false}
        defaultValues={{
          state: ["Pendiente", "En proceso"],
        }}
        filters={[
          {
            name: "state",
            label: "Estado",
            type: "select",
            multiple: true,
            data: [
              { id: "Pendiente", name: "Pendiente" },
              { id: "En proceso", name: "En proceso" },
              { id: "Finalizada", name: "Finalizada" },
            ],
          },
        ]}
      />
      <TableData
        dataRows={sortedTasks}
        loading={loading}
        onChangePage={page => setPage(page)}
        onChangeRowsPerPage={rowsPerPage => setRowsPerPage(rowsPerPage)}
        dataTitle={[
          "Fecha",
          "Alerta",
          "Tipo",
          "Detalle",
          "Estado",
          "Notas",
          "Cierre"
        ]}
        formatter={({ createdAt, alertEvent, type, detail, state, notes, closeDate }) => [
          moment(createdAt).format("DD/MM/YYYY HH:mm"),
          {
            type: 'button',
            value: alertEvent?.identification || "-",
            action: () => {
              if (alertEvent) {
                navigate(`/admin/alertas/eventos`, { state: { id: alertEvent?.identification } });
              }
            },
          },
          type,
          detail,
          state,
          notes && {
            type: "img",
            value: <Notes />,
            title: notes
          },
          closeDate ? moment(closeDate).format("DD/MM/YYYY HH:mm") : "-"
        ]}
        actions={[
          validatePermission('soporte', 'tareas', ['editar']) &&
          {
            label: "Editar",
            icon: <EditOutlined />,
            onClick: (data) => {
              handlerEdit(data);
            },
          },
          validatePermission('soporte', 'tareas', ['eliminar']) &&
          {
            label: "Eliminar",
            icon: <DeleteOutline />,
            onClick: (data) => {
              handlerDelete(data);
            }
          }
        ]}
      />
      <DialogModal
        open={dialog.open}
        title={dialog.title}
        body={dialog.body}
        maxWidth={dialog.maxWidth}
        textAlign={dialog.textAlign}
        onSuccess={dialog.onSuccess}
        onClose={dialog.onClose}
      />
    </>
  )
}

export default TaskScreen